/**
 * Created by RKL on 07/09/2015.
 */
define('adminLisSmpMatDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminLisSmpMatDetailsView',
  'emptyView',
  'lisSmpMatDetailTabController',
  'rolesMixin',
  'settings',
  'entities/lissmpmats'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  lisSmpMatDetailTabController
) {
  'use strict';

  var LisSmpMatsDetailsController = {
    fetchLisSmpMat: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showLisSmpMat(data);
      } else {
        this.model = App.request('lissmpmat:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showLisSmpMat(data);
          }
        });
      }
    },

    showLisSmpMat: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'lissmpmat:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (lisSmpMat) {
      this.view.onHeaderChange(lisSmpMat);
    },

    displayTabs: function(data) {
      lisSmpMatDetailTabController.showTab(data);
      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('admin/lissmpmats/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = LisSmpMatsDetailsController;
});
